<template>
  <LeadHistoryCard
    v-model:pick-up-call-target-id="pickUpCallTargetId"
    :text="actionTypeText"
    toggle
    :expand="expand"
    is-boxil-event
    icon="file_download"
    icon-type="boxil"
    :history="boxilLeadDownload"
    :call-target="callTarget"
    :call-target-id="callTargetId"
  >
    <template #date>
      <div>{{ historiedAt }}</div>
    </template>
    <BListItem>
      <template #header>
        <div>{{ $t('boxilLeadDownload.history.downloadDisplayType') }}</div>
      </template>
      <span>{{ boxilLeadDownload.downloadDisplayType }}</span>
    </BListItem>
    <BListItem class="mt-400">
      <template #header>
        <div>{{ $t('boxilLeadDownload.history.downloadName') }}</div>
      </template>
      <span>{{ boxilLeadDownload.downloadName }}</span>
    </BListItem>
  </LeadHistoryCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { CallTarget, HistoryCommon } from '@/api/openapi';
import LeadHistoryCard from '@/components/organisms/user/lead/history/LeadHistoryCard.vue';
import { formatShorterDateTime } from '@/utils/date-time';

type TProps = {
  callTargetId: number;
  boxilLeadDownload: HistoryCommon & {
    historiedAt: string;
    actionTypeText: string;
    downloadDisplayType: string;
    downloadName: string;
  };
  callTarget?: CallTarget;
  expand?: boolean;
}

const props = defineProps<TProps>();
defineOptions({
  inheritAttrs: false,
});

// v-model for pickUpCallTargetId to pass through to parent
const pickUpCallTargetId = defineModel<number>('pickUpCallTargetId');

const historiedAt = computed(() => {
  return formatShorterDateTime(props.boxilLeadDownload.historiedAt);
});

const actionTypeText = computed(() => {
  return props.boxilLeadDownload.actionTypeText;
});
</script>
